module.exports = __webpack_public_path__ + "static/media/bootstrap.ad9fadbc.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/bootstrap.png
// module id = 34
// module chunks = 0